var nodelist = Array.prototype.slice.call(document.querySelectorAll('li.nav-item__nested > a.nav-item__link'));
nodelist.forEach(function(list) {
    list.addEventListener('click', function(ev) {
        ev.target.classList.toggle('nav-item__link--active');
    }, false);
});

/**
 * Language dropdown for footer
 */
const langFooterDropdown = (() => {
    let langDropdown = document.getElementById("language-select-dropdown");
    let langDropList = document.getElementById("language-drop-down-list");
    let arrowButton = document.getElementsByClassName("language-arrow-icon");
    if( langDropdown ) {
        langDropdown.addEventListener('click', e => {
            langDropList.style.display = langDropList.style.display === 'none' ? 'block' : 'none';
            arrowButton && arrowButton[0].classList.toggle("down");
        })
    }
})()

/**
* Script to add horizontal accordion for wuplus mobile page
*/
function mobAccordionMenu() {
    const el = document.querySelectorAll('[id*="tab-wuplus-icon"]');
    if( el.length ) {
        for(let i=0;i<el.length;i++){
            el[i].addEventListener('click', e => {
                let tab_content = document.getElementById(`tab-wuplus-content${i+1}`);
                tab_content.classList.toggle("d-none");
            })
        }
    }
}